import { ComponentF } from "../../../ui/ui";
import { gameData } from "../../GameManager";

export const ContainsPanel: ComponentF<void> = (C) => {
  let y = C.bounds.y;
  gameData.player.contains.forEach((item) => {
    C.display.drawText(C.bounds.x, y, item.breed.name, C.bounds.w - 1);
    y += 1;
  });
};
